export default __webpack_public_path__ + "static/media/NeueMontreal-MediumItalic.21f2a6a6.woff";